const hasNumberValidator = {
  getMessage (field) {
    return 'The password must contain at least one number. Please try again.'
  },
  validate (value) {
    return /\d/.test(value)
  }
}

const hasUpperAndLowerLetterValidator = {
  getMessage (field) {
    return 'The password must contain at least one uppercase and one lower case character. Please try again.'
  },
  validate (value) {
    return value.search(/[a-z]/) > -1 && value.search(/[A-Z]/) > -1
  }
}

const hasUpperCaseValidator = {
  getMessage (field) {
    return 'The password must contain at least one uppercase character. Please try again.'
  },
  validate (value) {
    return value.search(/[A-Z]/) > -1
  }
}

const hasLowerCaseValidator = {
  getMessage (field) {
    return 'The password must contain at least one lowercase character. Please try again.'
  },
  validate (value) {
    return value.search(/[a-z]/) > -1
  }
}
/**
* Validate the field only contains letters, numbers and special characters allowed
*/
const hasSpecialCharacterValidator = {
  getMessage (field) {
    return "This field can contain only these special characters: ! # $ % * / ? I ^ { } ` ~ & ' + - = _. Please try again."
  },
  validate (value) {
    return value.replace(/[a-zA-Z0-9`~!@#$%^&*_+-=?'{}]/gi, '').length <= 0
  }
}

const birthDateFormatValidator = {
  getMessage (field) {
    return 'The value entered is not a valid date.'
  },
  validate (value) {
    if (value.length <= 7) {
      return false
    } else {
      let month = value.substring(0, 2)
      if (+month > 12 || +month <= 0) {
        return false
      }
      let days = value.substring(2, 4)
      if (+days > 31 || +days <= 0) {
        return false
      }

      const year = value.substring(4, 8)
      if (+year >= 2100 || +year <= 0) {
        return false
      }

      return true
    }
  }
}

export { hasNumberValidator, hasUpperAndLowerLetterValidator, hasSpecialCharacterValidator, birthDateFormatValidator, hasUpperCaseValidator, hasLowerCaseValidator }



// WEBPACK FOOTER //
// ./src/services/custom-validators.js